import { floatingActions } from '../../content/site';
import { usePrefersReducedMotion } from '../../hooks/useMotion';
import { useScrollProgress } from '../../hooks/useScrollProgress';

/*
 * Geniş ekranda (`lg+`, 940px) başa dön, içerik alanının DIŞINDAKİ boşlukta, kartların hemen yanında durur
 * (içeriğin üstüne binmesin): içerik kenarı = (100vw − 1200px) / 2 + 1.5rem; düğme bu kenarın 0.75rem sağında
 * biter → right = kenar − 0.75rem − düğme genişliği (48px). Boşluk dar kalırsa `max(1rem, …)` ile 1rem'e düşer,
 * hafif binme kabul. Sınıf adı DÜZ METİN yazılır: Tailwind kaynakta tam sınıf adını arar, şablon değişkeniyle
 * kurulan adı derlemez.
 */

const focusClass =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white';

export function ChevronUp({ size = 16 }: { size?: number }) {
  return (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="relative">
    <path d="M6 15l6-6 6 6" />
  </svg>
);
}

/**
 * Her sayfada sağ altta "başa dön": koyu cam daire, çevresinde kaydırma ilerlemesi kadar dolan ince degrade halka
 * (480px kaydırılınca belirir; ölçüm rAF ile). İletişim kısayolları (WhatsApp, arama) Z'eki hapına taşındı
 * (`components/assistant/AssistantDock`). Z'eki kapalıyken (`components/assistant/ContactDock`) telefonda çubuğun kendi başa dön parçası olur, bu halka telefonda gizlenir. Z'eki adası varken telefonda halka hapın üstünde durur (`bottom-[84px]` = 16px boşluk + 48px hap + 20px aralık; panel açılınca
 * `landing.css` onu gizler: `.zh-totop`), masaüstünde sağ altta ve `bottom-4` (16px): kapalı Z'eki adasıyla (`--zk-b0`, 48px) aynı
 * taban çizgisinde, aynı boyda durur. Cam yüzeyi (`.zh-totop` in `landing.css`) adayla birebir aynıdır; halka düğmenin kenarı olarak kalır.
 *
 * `z-30`: sabit üst bar ve açılır menü/pencerelerin altında kalır. SSR'da başa dön gizli, ilerleme 0 başlar.
 */
export function FloatingActions() {
  const reduced = usePrefersReducedMotion();
  const { showTop, progress } = useScrollProgress();

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });

  return (
    <button
      type="button"
      aria-label={floatingActions.scrollTop.label}
      title={floatingActions.scrollTop.label}
      tabIndex={showTop ? 0 : -1}
      onClick={scrollToTop}
      className={`zh-totop fixed bottom-[84px] right-4 z-30 flex h-12 w-12 items-center justify-center rounded-full text-[#c3d0e6] transition-[opacity,transform,color] duration-[250ms] hover:text-white lg:bottom-4 lg:right-[max(1rem,calc((100vw_-_1200px)/2_+_0.75rem_-_48px))] ${focusClass} ${
        showTop ? 'opacity-100' : 'pointer-events-none translate-y-2 opacity-0'
      }`}
    >
      <svg viewBox="0 0 44 44" aria-hidden="true" className="absolute inset-0 h-full w-full -rotate-90">
        <defs>
          <linearGradient id="zh-totop-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#45c0ee" />
          </linearGradient>
        </defs>
        <circle cx="22" cy="22" r="20" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="2" />
        <circle
          cx="22"
          cy="22"
          r="20"
          fill="none"
          stroke="url(#zh-totop-grad)"
          strokeWidth="2"
          strokeLinecap="round"
          pathLength={100}
          strokeDasharray="100"
          strokeDashoffset={100 - Math.round(progress * 100)}
          style={reduced ? undefined : { transition: 'stroke-dashoffset 120ms linear' }}
        />
      </svg>
      <ChevronUp />
    </button>
  );
}
